module.exports = __webpack_public_path__ + "media/promo/courses/images/casem-f70198531c2d6f3e8651a81a72c78500.jpg";